// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__14Vw6","zerosbutton":"Modal_zerosbutton__G1jXI","zeroslink":"Modal_zeroslink__6IrOA","footer":"Modal_footer__3ayvR","overlay":"Modal_overlay__bZoXs"};